import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isThisHour } from 'date-fns';
import { da, tr } from 'date-fns/locale';
import { CalendarComponent } from '../calendar/calendar.component';
import { ActionsService } from '../services/actions.service';
import { DateService } from '../services/date.service';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-avt-planning',
  templateUrl: './avt-planning.component.html',
  styleUrls: ['./avt-planning.component.scss']
})
export class AvtPlanningComponent implements OnInit {

  constructor(public generalService: GeneralService,public route: ActivatedRoute,public actionsService :ActionsService,public dateServise : DateService,public router:Router) { }
  ecran : string;
  titre : string;
  code : string = "-1";
  items = [];
  listWeek = [];
  listMonth = [];
  events = [];
  showCalendar : boolean = false;
  disabled : boolean = false;
  intervale : number = 30;
  date_Fin : Date
  date_Debut : Date;
  defaultDate : Date;
  date;
  numColonneToShow = 1;
  recherche : string;
  param1Recherche : string;
  param2Recherche : string;
  liste = [];
  url : string = "";
  param : string = ""
  showRecherche : boolean = false;
  listeCollaborateurs = []
  listeClients = [];
  listeActions = [];
  listeCollaborateursIsLoadet : boolean = false
  listeClientsIsLoadet : boolean = false;
  avtAction_Code : string = "";
  @ViewChild("calendarComponent", {static : false}) calendarComponent : CalendarComponent
  ngOnInit() 
  {
    this.readParamUrl();   
    // this.getListeCollaborateur();
    // this.getListeClients();
  }
  // getListeCollaborateur()
  // {
  //   this.generalService.rechercheTable("recherche/tbdata?tablere=avtperso&param=0").subscribe(data => 
  //   {   
  //     this.listeCollaborateurs = data;
  //     this.listeCollaborateursIsLoadet = true;
  //   })
  // }
  // getListeClients()
  // {
  //   this.generalService.rechercheTable("recherche/tbdata?tablere=avtclient&param=1").subscribe(data => 
  //   {   
  //     this.listeClients = data;
  //     this.listeClientsIsLoadet = true;
  //   })
  // }
  showDetaille(date, view)
  {
    if(this.code != "-1" || this.ecran =="action")
    {
      this.calendarComponent.setOption("validRange",{start: this.date_Debut, end:  this.date_Fin})
      this.calendarComponent.changeView(view)
      this.calendarComponent.setDefaulDate(this.dateServise.convertStrToDate(date));
    }
    else
      this.generalService.dialogSuccess("SVP veuillez SVP remplir le formulaire ci-dessous",false)
  }
  initDate()
  {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth()-2);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth()+2);
    this.date_Fin.setDate(1);
    this.listWeek = this.dateServise.getListWeek(this.date_Debut,this.date_Fin);
    this.listMonth = this.dateServise.getListMonth(this.date_Debut,this.date_Fin,0);
  }
  getUrl()
  {
    return this.url + this.dateServise.setFormatDateRechercheServer(this.date_Debut)+","+this.dateServise.setFormatDateRechercheServer(this.date_Fin) + this.param
  }
  init(initDate? : boolean)
  {
    if(this.calendarComponent)
      this.calendarComponent.setEventCalandar([]);
    if(initDate)
      this.initDate();
    if(this.ecran == "client")
    {
      this.titre = "CLIENT";
      this.numColonneToShow = 1;
      this.recherche = "TierType";
      this.param1Recherche = "1";
      this.param2Recherche = null;
      this.url = "recherche/tbdata?tablere=avtActionlpc&param=";
      this.param = ",%,"+this.code+",%"
    }
    else if(this.ecran == "collaborateur")
    {
      this.titre = "COLLABORATEUR";
      this.numColonneToShow = 1;
      this.recherche = "avtAcollaborateur";
      this.param1Recherche = "0";
      this.param2Recherche = null;
      this.url = "recherche/tbdata?tablere=avtActionlpc&param=";
      this.param = "," + this.code +",%,%"
    }
    else if(this.ecran == "action")
    {
      this.titre = "ACTION";
      this.numColonneToShow = 1;
      this.recherche = "avtAcollaborateur";
      this.param1Recherche = "0";
      this.param2Recherche = null;
      this.url = "recherche/tbdata?tablere=avtActionlpc&param=";
      this.param = ",%,%,"+ this.code;
    }
    else if(this.ecran == "vehicule")
    {
      this.titre = "VÉHICULE";
      this.numColonneToShow = 1;
      this.recherche = "Machineft";
      this.param1Recherche = "1";
      this.param2Recherche = "1";
      this.url = "recherche/tbdata?tablere=avtReservationEL&param=";
      this.param = ",1,1";
    }
    else if(this.ecran == "materiel")
    {
      this.titre = "MATÉRIEL";
      this.numColonneToShow = 1;
      this.recherche = "Machineft";
      this.param1Recherche = "1";
      this.param2Recherche = "3";
      this.url = "recherche/tbdata?tablere=avtReservationEL&param=";
      this.param = ",1,2";
    }
    // recherche par Machineft :
    // parm : pour Machine_Type  
    // Véhicules :1,   Éqipement multimédia :2,   Équipement industriel :3,   Équipements BTP :4
    
    // param2 : pour Machine_Famille1
    // 1 machine (véhicule ,equipement multimedia, equipement btp...)
    // 2 salle
    setTimeout(()=>
    {
      this.showRecherche = true;
    },50)
    if(this.code != "-1"|| this.ecran == "action")
      this.getData()
  }
  genererTitre(actionD) : string
  {
    var client = actionD.Tiers_NomPublic? "<b>Client:</b> " + actionD.Tiers_NomPublic : "";
    var titre : string = "<div style='background-color: #3c9b30;color: white;width: 100%;padding: 2px;border-radius: 5px;'>" + 
                            actionD.avtActionD_Info + 
                            " <br>" + 
                            client + 
                          "</div>"
    return titre
  }
  createEventsCalandar(listeActionD)
  {
    var events = [];
    listeActionD.forEach(actionD => 
    {
      var titre = this.genererTitre(actionD)
      if(this.generalService.isNotEmpty(actionD.avtActionD_heureDebAM) && actionD.avtActionD_heureDebAM != "00:00:00.0000000"&& actionD.avtActionD_heureDebAM != "00:00"&& actionD.avtActionD_heureDebAM != "00:00:00")
      {
        var eventAM = this.actionsService.createEvent(actionD,titre,actionD.avtActionD_Code + "_AM",new Date(this.dateServise.setToFormatDateServerStr(actionD.avtActionD_date) + " " + actionD.avtActionD_heureDebAM),new Date(this.dateServise.setToFormatDateServerStr(actionD.avtActionD_date) + " " + actionD.avtActionD_heureFinAM),"","",null,false)
        events.push(eventAM);
      }
      if(this.generalService.isNotEmpty(actionD.avtActionD_heureDebPM) && actionD.avtActionD_heureDebPM != "00:00:00.0000000"&& actionD.avtActionD_heureDebPM != "00:00"&& actionD.avtActionD_heureDebPM != "00:00:00")
      {
        var eventPM = this.actionsService.createEvent(actionD,titre,actionD.avtActionD_Code + "_PM",new Date(this.dateServise.setToFormatDateServerStr(actionD.avtActionD_date) + " " + actionD.avtActionD_heureDebPM),new Date(this.dateServise.setToFormatDateServerStr(actionD.avtActionD_date) + " " + actionD.avtActionD_heureFinPM),"#3c9b30","white",null,false)
        events.push(eventPM);
      }
    });
    return events;
  }
  convertReservationToActionD(data)
  {
    var actionD = []
    data.forEach(ele =>
    {
      var nbrDay = this.dateServise.dateDiff(this.dateServise.setFormatDateServer(ele.DateDebut),this.dateServise.setFormatDateServer(ele.DateFin))
      var date = new Date(ele.DateDebut)
      for(var i = 0 ; i < nbrDay ; i++)
      {
        actionD.push
        ({
          avtActionD_Info : ele.Machine_Lib,
          avtActionD_Code :ele.id + "_" + i,
          avtActionD_date : this.dateServise.setToFormatDateServerStr(date),
          avtActionD_heureDebAM : ele.HeureDebutAm, 
          avtActionD_heureFinAM : ele.HeureFinAm ,
          avtActionD_heureDebPM : ele.HeureDebutPm, 
          avtActionD_heureFinPM : ele.HeureFinPm,
          Tiers_code : ele.Tiers_code,
          Tiers_NomPublic : ele.Tiers_NomPublic
        })
          
        date.setDate(date.getDate()+1)
      }
    });
    return actionD
  }
  getData()
  {
    if(this.code != "-1"|| this.ecran == "action")
    {
      this.showCalendar = false
      this.generalService.rechercheTable(this.getUrl()).subscribe(data =>
      {
        if(this.ecran == "vehicule" || this.ecran == "materiel")
        data = this.convertReservationToActionD(data.filter(d =>{return d.Machine_Code == this.code}))
        this.liste = data;
        this.events = this.createEventsCalandar(data)
        this.activerDesactiverBtnMoidWeek()
        if(this.ecran == "action")
        this.setListeActions(data)
        this.calendarComponent.setEventCalandar(this.events);
      })        
    }
  }
  activerDesactiverBtnMoidWeek()
  {
    this.listMonth.forEach(month =>
    {
      month.enable = this.isMonthPlanifiable(month);
    })
    this.listWeek.forEach(week =>
    {
      week.enable = this.isWeekPlanifiable(week);
    })
  }
  isMonthPlanifiable(month) : boolean
  {
    var planifiable = false
    this.events.forEach(datePlanifiable =>
    {
      var date = datePlanifiable.start
      if(month.monthId == date.getMonth() && month.year == date.getFullYear())
        planifiable = true;
    });
    return planifiable
  }
  isWeekPlanifiable(week) : boolean
  {
    var planifiable = false;
    var dateWeek = this.dateServise.convertStrToDate(week.monthName)
    this.events.forEach(datePlanifiable =>
    {
      var date = datePlanifiable.start
      if(week.colSpan == this.dateServise.getWeekNumber(date) && dateWeek.getFullYear() == date.getFullYear())
        planifiable = true;
    });
    return planifiable
  }
  actionChange()
  {
    this.events = this.createEventsCalandar(this.liste.filter(lst =>{return lst.avtAction_Code == this.code}))
    this.calendarComponent.setEventCalandar(this.events);
    this.activerDesactiverBtnMoidWeek()
  }
  setListeActions(data)
  {
    var codeAction = this.generalService.distinct(data,"avtAction_Code")
    codeAction.forEach(code => {
      this.listeActions.push({avtAction_Code : code, avtAction_Intitule : data.find(action => {return action.avtAction_Code == code}).avtAction_Intitule})
    });
  }
  blurChamp(event)
  {
    this.code = event;
    this.showCalendar = false;
    this.init()
  }
  dateChange()
  {
    this.showCalendar = false;
    this.listWeek = this.dateServise.getListWeek(this.date_Debut,this.date_Fin);
    this.listMonth = this.dateServise.getListMonth(this.date_Debut,this.date_Fin,0);
    this.calendarComponent.setOption("validRange",{start: this.date_Debut, end:  this.date_Fin})
    this.init();
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.showRecherche = false;
      this.ecran = params['ecran'];
      this.date = params['date'];
      this.intervale = params['intervale'];
      this.code = params['param_code'];    
      this.init(true);
    });
  }
}
